import React from 'react';
import ReactGA from 'react-ga';

import { Page } from '../components';
import {
  PrimaryContent,
  SignatureContent,
} from '../components/Content/DeclarationScreen';

ReactGA.pageview(window.location.pathname + window.location.search);

const DeclarationScreen = () => (
  <Page id="main">
    <PrimaryContent />
    <SignatureContent />
  </Page>
);

export default DeclarationScreen;
